var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "all-seller-modal",
      "visible": _vm.visible,
      "hide-footer": "",
      "title": "All Sellers Rep",
      "centered": ""
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "d-flex gap-2 flex-wrap"
  }, [_c('p', {
    staticClass: "split-pill mb-2 mr-2"
  }, [_vm._v("Joy Smith")]), _c('p', {
    staticClass: "split-pill mb-2 mr-2"
  }, [_vm._v("Joy Smith")]), _c('p', {
    staticClass: "split-pill mb-2 mr-2"
  }, [_vm._v("Joy Smith")]), _c('p', {
    staticClass: "split-pill mb-2 mr-2"
  }, [_vm._v("Joy Smith")]), _c('p', {
    staticClass: "split-pill mb-2 mr-2"
  }, [_vm._v("Joy Smith")]), _c('p', {
    staticClass: "split-pill mb-2 mr-2"
  }, [_vm._v("Joy Smith")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }